<mat-card class="mat-elevation-z2">
  <mat-card-title>
    <p8-layout-settings-header [iconRacine]="'group'"
                               [titlePath]="['Inviter des personnes à donner leur avis sur cette demande']"></p8-layout-settings-header>

  </mat-card-title>
  <mat-card-subtitle>Les invités pourront consulter la demande pour donner leur avis (favorable / défavorable / suspendu
    ou autre), ils ne pourront modifier la demande
  </mat-card-subtitle>
  <mat-card-content *ngIf="lastInstructionState !== responseInstruction.in_progress">
    <mark>La demande n'est pas en cours de traitement, la demande d'avis ne peut être effectuée</mark>
  </mat-card-content>
  <mat-card-content *ngIf="lastInstructionState === responseInstruction.in_progress">
    <mat-error *ngIf="allReadyExist">{{allReadyExist}}</mat-error>
    <div class="container">
      <app-search-ldap (ldapUserSelected)="onSelectIndividuLdap($event)"
                       [ldapDisplayProperty]="'cn,mail'"
                       [mode]="'light'"
                       [placeHolder]="'Rechercher une personne dans l\'annuaire LDAP puis la sélectionner pour l\'ajouter aux destinataires...'"
                       [removeDiatrics]="true"
                       [scope]="true"
                       [scopesToDisplay]="['employee', 'faculty', 'researcher', 'student']"
                       [title]="false"
                       class="ldap-search">
      </app-search-ldap>
      <ng-container *ngIf="groupListsSelect.length > 0">
        <div class="separator">OU</div>
        <mat-form-field appearance="fill" class="lists-select">
          <mat-label>Sélectionner une ou plusieurs personnes dans une de vos listes prédéfinies</mat-label>
          <mat-select
            multiple
            (valueChange)="onSelectListRequesters($event)"
            matTooltip="Sélectionner une ou plusieurs personnes dans une de vos listes prédéfinies"
            placeholder="Sélectionner une ou plusieurs personnes dans vos listes prédéfinies">
            <mat-optgroup *ngFor="let group of groupListsSelect"
                          label="{{group.listName}} (cliquer ici pour tout sélectionner)"
                          matTooltip="Cliquer sur le nom du groupe pour sélectionner toutes les personnes de cette liste"
                          matTooltipPosition="right"
                          class="clickable-optgroup"
                          (click)="toggleGroupSelection(group, $event)">
              <mat-option *ngFor="let person of group.requesters"
                          [matTooltip]="person.informations"
                          [value]="person">
                {{person.displayName}} <span *ngIf="person.informations">({{person.informations|truncate:30}})</span>
              </mat-option>
            </mat-optgroup>
          </mat-select>
        </mat-form-field>
      </ng-container>
    </div>
    <div *ngIf="listGuests.length > 0">
      <mat-drawer-container autosize class="ex-container">

        <div class="ex-sidenav-content">
          <div>
            <h2>Liste des personnes concernées à donner leur avis :
              <button (click)="drawer.toggle()" *ngIf="!drawer.opened"
                      [matTooltip]="'Afficher la fiche de réponse'"
                      mat-mini-fab
                      [color]="'accent'"
                      type="button">
                <mat-icon>visibility</mat-icon>
              </button>
            </h2>
            <mat-chip-listbox>
              <mat-chip-option *ngFor="let guest of listGuests" removable>
          <span style="display: flex; align-items: center">
            <span>{{guest.displayName}} {{guest.email}}</span>
            <span class="spacer"></span>
            <button (click)="deleteGuestChip(guest)" [matTooltip]="'Enlever cette personne'"
                    aria-label="enlever cette personne" data-cy="button-remove-guest-chip"
                    matChipRemove>
                <mat-icon class="mat-16">close</mat-icon>
            </button>
          </span>
              </mat-chip-option>
            </mat-chip-listbox>
          </div>
          <div style="padding-top: 20px;">
            <mat-form-field appearance="outline" fxFlex="80">
              <mat-label>Message d'introduction</mat-label>
              <textarea [(ngModel)]="INTRODUCTION" data-cy="txt-area-avis-introduction"
                        matInput
                        placeholder="Introduction au message qui sera envoyé"
                        rows="3"
                        type="text"></textarea>
            </mat-form-field>
          </div>
          <div>
            <button (click)="sendOpinion()" color="primary" mat-raised-button>Demander un avis</button>
          </div>
        </div>
        <mat-drawer #drawer class="ex-sidenav" mode="side" position="end">
          <button (click)="drawer.toggle()" *ngIf="drawer.opened"
                  [matTooltip]="'Masquer la fiche de réponse'"
                  mat-mini-fab
                  [color]="'primary'"
                  type="button">
            <mat-icon>close</mat-icon>
          </button>
          <app-simple-reponse-fiche [hideMenu]="true" [response]="response"></app-simple-reponse-fiche>
        </mat-drawer>

      </mat-drawer-container>
    </div>

  </mat-card-content>
</mat-card>
